import React from 'react';
import { number } from 'prop-types';
import { getContext } from '@fiverr-private/fiverr_context';
import { I18n } from '@fiverr-private/i18n-react';
import { ChevronLeftIcon, ChevronRightIcon } from '@fiverr-private/visuals';
import { Stack } from '@fiverr-private/layout_components';
import { maxPagesLimit } from '../../../utils/pagesLimit';
import { DEFAULT_PAGE } from '../../../constants';
import { MIN_PAGE_TO_FIRST_PAGE } from './constants';
import { getPaginationRange, isCurrentPage } from './utils';
import { PaginationItem } from './PaginationItem';

export const Pagination = ({ currentPage: cp, numOfGigs }) => {
    const {
        isTouch,
        queryParameters: { page = DEFAULT_PAGE },
    } = getContext();

    const currentPage = parseInt(page, 10) || cp;

    const totalPages = maxPagesLimit(numOfGigs);

    const { startPage, endPage } = getPaginationRange({
        totalPages,
        currentPage,
    });

    const showLeftArrow = currentPage !== 1;
    const showRightArrow = currentPage < totalPages;
    const showArrowToFirstPage = page >= (isTouch ? MIN_PAGE_TO_FIRST_PAGE.TOUCH : MIN_PAGE_TO_FIRST_PAGE.DESKTOP);

    const numberOfPages = endPage - startPage + 1;
    const pageNumbers = Array.from({ length: numberOfPages }, (_, i) => i + startPage);

    return (
        <Stack as="ul" justifyContent="center" marginY="8" gap="1">
            {showArrowToFirstPage && (
                <PaginationItem key="first-page-arrows" page={1} dataTestid="go-first-page">
                    <ChevronLeftIcon color="grey_900" size="sm" />
                    <ChevronLeftIcon color="grey_900" size="sm" />
                </PaginationItem>
            )}

            {showLeftArrow && (
                <PaginationItem key="left-arrows" page={currentPage - 1} dataTestid="go-prev-page">
                    <ChevronLeftIcon color="grey_900" />
                </PaginationItem>
            )}

            {isTouch ? (
                <PaginationItem key="current-page" page={currentPage} isCurrentPage={true} dataTestid="current-page">
                    <I18n k="tag_page_perseus.pagination.page" params={{ currentPage }} />
                </PaginationItem>
            ) : (
                pageNumbers.map((page) => {
                    const isCurrentPageResult = isCurrentPage(page, currentPage);
                    return (
                        <PaginationItem
                            key={page}
                            page={page}
                            isCurrentPage={isCurrentPageResult}
                            dataTestid={isCurrentPageResult ? 'current-page' : 'go-to-x-page'}
                        >
                            {page}
                        </PaginationItem>
                    );
                })
            )}

            {showRightArrow && (
                <PaginationItem key="right-arrows" page={currentPage + 1} dataTestid="go-next-page">
                    <ChevronRightIcon color="grey_900" />
                </PaginationItem>
            )}
        </Stack>
    );
};

Pagination.propTypes = {
    currentPage: number,
    numOfGigs: number,
};
